/* eslint-disable react/prop-types */
import React, { FC } from "react";
import { Check } from "lucide-react";

interface Props {
	variant: string;
	isSelected?: boolean;
	onChange?: () => void;
}

const BannerVariant: FC<Props> = ({
	variant,
	isSelected = false,
	onChange
}) => {
	const getColor = () => {
		if (variant === "black") return "black";
		if (variant === "white") return "white";
		return "#f4f4f5";
	};

	return (
		<label className="cursor-pointer text-center">
			<input
				type="radio"
				checked={isSelected}
				onChange={() => onChange?.()}
				aria-label={`button-variant-${variant}`}
				className="sr-only"
			/>
			<span
				aria-hidden={true}
				style={{ display: "none" }}
				data-testid="test-variant"
				role="note"
			>
				{getColor()}
			</span>
			<div
				className={[
					"relative rounded-lg p-2 transition-all",
					isSelected
						? "border-2 border-primary bg-primary-lighter"
						: "border border-border bg-white hover:border-border hover:shadow-sm"
				].join(" ")}
			>
				{isSelected && (
					<span className="absolute -top-2 -right-2 h-5 w-5 bg-primary text-white rounded-full flex items-center justify-center">
						<Check className="h-3 w-3" />
					</span>
				)}
				<div
					className="rounded h-10 w-[88px]"
					style={{ backgroundColor: getColor() }}
				/>
			</div>
			<span
				className={[
					"block text-[11px] mt-1 transition-opacity",
					isSelected ? "text-primary font-medium" : "text-transparent"
				].join(" ")}
			>
				Selected
			</span>
		</label>
	);
};

export default BannerVariant;
